const jobPosts = {
  "job_posts": [
    {
      "job_id": 1,
      "job_title": "Sales Trainee (Fresher – Non-Engineering Graduates)",
      "author": "admins",
      "published_date": "October 22, 2024",
      "job_brief": "We are looking for dynamic freshers who have completed their degree in non-engineering fields.",
      "responsibilities": [
        "Assist in sales initiatives, including lead generation and client interaction",
        "Participate in on-the-job training and real-time sales projects"
      ],
      "requirements": [
        "Bachelor’s degree in non-engineering fields",
        "Strong communication skills"
      ],
      "years_of_experience": "0-1 years",
      "job_type": "Full Time",
      "job_category": "Sales",
      "job_location": "Bangalore",
      "language_proficiency": ["English", "Kannada"],
      "content": "Selected candidates will undergo a training program and become permanent employees.",
      "education": "Bachelor’s degree in any field",
      "skillsets": ["Sales", "Client interaction", "Communication skills"]
    },
    {
      "job_id": 2,
      "job_title": "Senior Marketing Manager",
      "author": "hr_admin",
      "published_date": "October 20, 2024",
      "job_brief": "We are looking for an experienced Senior Marketing Manager to lead our marketing team.",
      "responsibilities": [
        "Oversee marketing campaigns",
        "Manage team of marketing professionals",
        "Develop strategies to improve brand presence"
      ],
      "requirements": [
        "Bachelor's degree in Marketing or a related field",
        "5+ years of experience in marketing"
      ],
      "years_of_experience": "5+ years",
      "job_type": "Full Time",
      "job_category": "Marketing",
      "job_location": "Mumbai",
      "language_proficiency": ["English", "Hindi"],
      "content": "Lead and grow the marketing department with cutting-edge strategies.",
      "education": "Bachelor’s or Master’s degree in Marketing",
      "skillsets": ["Leadership", "Campaign management", "Brand strategy", "Team management"]
    },
    {
      "job_id": 3,
      "job_title": "Junior Software Developer",
      "author": "tech_admin",
      "published_date": "October 15, 2024",
      "job_brief": "We are seeking a Junior Developer with strong coding skills in JavaScript and Python.",
      "responsibilities": [
        "Write clean and scalable code",
        "Collaborate with cross-functional teams"
      ],
      "requirements": [
        "Bachelor's degree in Computer Science",
        "Strong problem-solving skills"
      ],
      "years_of_experience": "1-2 years",
      "job_type": "Full Time",
      "job_category": "IT",
      "job_location": "Hyderabad",
      "language_proficiency": ["English"],
      "content": "You will be working in a dynamic tech environment with mentorship opportunities.",
      "education": "Bachelor’s degree in Computer Science or related field",
      "skillsets": ["JavaScript", "Python", "Problem-solving", "Teamwork"]
    },
    {
      "job_id": 4,
      "job_title": "HR Assistant",
      "author": "hr_admin",
      "published_date": "October 10, 2024",
      "job_brief": "Support the HR department in various administrative tasks.",
      "responsibilities": [
        "Assist in recruitment processes",
        "Maintain employee records"
      ],
      "requirements": [
        "Bachelor's degree in Human Resources or a related field",
        "Strong organizational skills"
      ],
      "years_of_experience": "0-2 years",
      "job_type": "Full Time",
      "job_category": "HR",
      "job_location": "Delhi",
      "language_proficiency": ["English", "Hindi"],
      "content": "The HR Assistant will play a crucial role in supporting recruitment and employee relations.",
      "education": "Bachelor’s degree in Human Resources or Business Administration",
      "skillsets": ["Recruitment", "Administration", "Employee Relations", "Organization skills"]
    },
    {
      "job_id": 5,
      "job_title": "Digital Marketing Executive",
      "author": "marketing_admin",
      "published_date": "October 12, 2024",
      "job_brief": "Execute digital marketing campaigns across social media and search engines.",
      "responsibilities": [
        "Create content for social media platforms",
        "Analyze campaign performance"
      ],
      "requirements": [
        "Bachelor's degree in Marketing or relevant experience",
        "Knowledge of SEO and SEM"
      ],
      "years_of_experience": "2-3 years",
      "job_type": "Full Time",
      "job_category": "Marketing",
      "job_location": "Chennai",
      "language_proficiency": ["English", "Tamil"],
      "content": "You will manage various digital marketing channels to drive online traffic.",
      "education": "Bachelor’s degree in Marketing, Communication, or a related field",
      "skillsets": ["SEO", "SEM", "Content Creation", "Campaign analysis"]
    },
    {
      "job_id": 6,
      "job_title": "Customer Support Specialist",
      "author": "support_admin",
      "published_date": "October 18, 2024",
      "job_brief": "Provide excellent customer support through various communication channels.",
      "responsibilities": [
        "Respond to customer queries",
        "Resolve issues in a timely manner"
      ],
      "requirements": [
        "Bachelor's degree or equivalent experience",
        "Strong communication and problem-solving skills"
      ],
      "years_of_experience": "1-3 years",
      "job_type": "Full Time",
      "job_category": "Customer Support",
      "job_location": "Kolkata",
      "language_proficiency": ["English", "Bengali"],
      "content": "You will assist customers with product and service inquiries, ensuring satisfaction.",
      "education": "Bachelor’s degree in Business, Communication, or related fields",
      "skillsets": ["Customer service", "Problem-solving", "Communication", "Multitasking"]
    },
    {
      "job_id": 7,
      "job_title": "Operations Manager",
      "author": "ops_admin",
      "published_date": "October 14, 2024",
      "job_brief": "Manage day-to-day operations and ensure smooth business processes.",
      "responsibilities": [
        "Oversee operational processes",
        "Manage team members and workflow"
      ],
      "requirements": [
        "Bachelor's degree in Business Management",
        "5+ years of experience in operations"
      ],
      "years_of_experience": "5+ years",
      "job_type": "Full Time",
      "job_category": "Operations",
      "job_location": "Pune",
      "language_proficiency": ["English", "Marathi"],
      "content": "Lead operational improvements and ensure business efficiency.",
      "education": "Bachelor’s degree in Business Management or Operations",
      "skillsets": ["Operations management", "Team leadership", "Process optimization", "Workflow management"]
    },
    {
      "job_id": 8,
      "job_title": "Graphic Designer",
      "author": "design_admin",
      "published_date": "October 8, 2024",
      "job_brief": "Create visually appealing designs for digital and print media.",
      "responsibilities": [
        "Design banners, brochures, and web graphics",
        "Collaborate with marketing teams"
      ],
      "requirements": [
        "Bachelor's degree in Graphic Design",
        "Proficiency in Adobe Creative Suite"
      ],
      "years_of_experience": "2-4 years",
      "job_type": "Full Time",
      "job_category": "Design",
      "job_location": "Bangalore",
      "language_proficiency": ["English"],
      "content": "You will create compelling visual designs to support marketing campaigns.",
      "education": "Bachelor’s degree in Graphic Design or a related field",
      "skillsets": ["Adobe Creative Suite", "Graphic Design", "Creativity", "Teamwork"]
    },
    {
      "job_id": 9,
      "job_title": "Business Analyst",
      "author": "analytics_admin",
      "published_date": "October 16, 2024",
      "job_brief": "Analyze business data to provide actionable insights for decision-making.",
      "responsibilities": [
        "Gather and analyze business requirements",
        "Create reports and dashboards"
      ],
      "requirements": [
        "Bachelor's degree in Business Analytics or related field",
        "Strong analytical skills"
      ],
      "years_of_experience": "3-5 years",
      "job_type": "Full Time",
      "job_category": "Analytics",
      "job_location": "Mumbai",
      "language_proficiency": ["English"],
      "content": "You will work closely with stakeholders to optimize business strategies.",
      "education": "Bachelor’s degree in Business Analytics or Data Science",
      "skillsets": ["Data analysis", "Report generation", "Business intelligence", "Dashboard tools"]
    },
    {
      "job_id": 10,
      "job_title": "Project Manager",
      "author": "pm_admin",
      "published_date": "October 5, 2024",
      "job_brief": "Lead projects from initiation to completion, ensuring timely delivery.",
      "responsibilities": [
        "Manage project timelines and deliverables",
        "Coordinate with cross-functional teams"
      ],
      "requirements": [
        "Bachelor's degree in Project Management or related field",
        "PMP certification preferred"
      ],
      "years_of_experience": "5+ years",
      "job_type": "Full Time",
      "job_category": "Project Management",
      "job_location": "Hyderabad",
      "language_proficiency": ["English", "Telugu"],
      "content": "You will oversee project execution, managing risks and ensuring client satisfaction.",
      "education": "Bachelor’s or Master’s degree in Project Management or related field",
      "skillsets": ["Project management", "Risk management", "Team coordination", "Client management"]
    },
    {
      "job_id": 11,
      "job_title": "Financial Analyst",
      "author": "finance_admin",
      "published_date": "October 23, 2024",
      "job_brief": "Analyze financial data and assist in strategic financial decision-making for the company.",
      "responsibilities": [
        "Prepare financial reports and forecasts",
        "Analyze financial performance and trends"
      ],
      "requirements": [
        "Bachelor's degree in Finance or Accounting",
        "3-5 years of experience in financial analysis"
      ],
      "years_of_experience": "3-5 years",
      "job_type": "Full Time",
      "job_category": "Finance",
      "job_location": "Mumbai",
      "language_proficiency": ["English", "Hindi"],
      "content": "The Financial Analyst will provide key insights for financial planning and business growth.",
      "education": "Bachelor’s degree in Finance, Accounting, or Economics",
      "skillsets": ["Financial analysis", "Excel", "Data interpretation", "Financial modeling"]
    },
    {
      "job_id": 12,
      "job_title": "Senior HR Manager",
      "author": "hr_admin",
      "published_date": "October 21, 2024",
      "job_brief": "Lead and manage the HR department with a focus on recruitment, employee engagement, and compliance.",
      "responsibilities": [
        "Develop and implement HR strategies",
        "Lead recruitment and talent acquisition efforts",
        "Ensure compliance with labor laws"
      ],
      "requirements": [
        "Bachelor's degree in Human Resources or related field",
        "7+ years of experience in HR management"
      ],
      "years_of_experience": "7+ years",
      "job_type": "Full Time",
      "job_category": "HR",
      "job_location": "Delhi",
      "language_proficiency": ["English", "Hindi"],
      "content": "The Senior HR Manager will play a critical role in building a high-performing and engaged workforce.",
      "education": "Bachelor’s or Master’s degree in Human Resources or Business Management",
      "skillsets": ["HR management", "Employee relations", "Talent acquisition", "Compliance"]
    },
    {
      "job_id": 13,
      "job_title": "Machine Learning Engineer",
      "author": "tech_admin",
      "published_date": "October 19, 2024",
      "job_brief": "Develop and implement machine learning models to drive innovation and improve business processes.",
      "responsibilities": [
        "Build machine learning models for data analysis",
        "Collaborate with data scientists and software engineers"
      ],
      "requirements": [
        "Master's degree in Computer Science or related field",
        "Experience with Python, TensorFlow, and machine learning frameworks"
      ],
      "years_of_experience": "3-5 years",
      "job_type": "Full Time",
      "job_category": "IT",
      "job_location": "Bangalore",
      "language_proficiency": ["English"],
      "content": "The Machine Learning Engineer will contribute to cutting-edge AI solutions in a fast-paced environment.",
      "education": "Master’s degree in Computer Science, Data Science, or related field",
      "skillsets": ["Python", "TensorFlow", "Machine Learning", "Data modeling", "AI development"]
    },
    {
      "job_id": 14,
      "job_title": "Supply Chain Manager",
      "author": "operations_admin",
      "published_date": "October 17, 2024",
      "job_brief": "Oversee and manage the entire supply chain process to ensure efficient product delivery.",
      "responsibilities": [
        "Manage logistics and supply chain operations",
        "Develop strategies to improve supply chain efficiency"
      ],
      "requirements": [
        "Bachelor's degree in Supply Chain Management or related field",
        "5+ years of experience in supply chain management"
      ],
      "years_of_experience": "5+ years",
      "job_type": "Full Time",
      "job_category": "Operations",
      "job_location": "Pune",
      "language_proficiency": ["English", "Marathi"],
      "content": "The Supply Chain Manager will optimize and streamline supply chain processes for cost-effective operations.",
      "education": "Bachelor’s or Master’s degree in Supply Chain Management or Logistics",
      "skillsets": ["Supply chain management", "Logistics", "Inventory management", "Process optimization"]
    },
    {
      "job_id": 15,
      "job_title": "Front-end Developer",
      "author": "tech_admin",
      "published_date": "October 22, 2024",
      "job_brief": "Design and develop user-facing applications using modern front-end technologies.",
      "responsibilities": [
        "Develop responsive web pages",
        "Collaborate with back-end developers and designers"
      ],
      "requirements": [
        "Bachelor's degree in Computer Science or related field",
        "Proficiency in HTML, CSS, JavaScript, and React"
      ],
      "years_of_experience": "2-4 years",
      "job_type": "Full Time",
      "job_category": "IT",
      "job_location": "Chennai",
      "language_proficiency": ["English", "Tamil"],
      "content": "As a Front-end Developer, you will create dynamic, responsive web applications that enhance user experience.",
      "education": "Bachelor’s degree in Computer Science or related field",
      "skillsets": ["HTML", "CSS", "JavaScript", "React", "UI development"]
    }
    
  ]
}

export default jobPosts;
